import axios from 'axios';
import ApiClient from '../apiClient';

const partnerAuthService = {
  signIn: (data: any) => ApiClient.post('/auth/partner/login', data),
  signUp: (data: any) => ApiClient.post('/auth/partner/registration', data),
  getMe: (data: any) => ApiClient.get('/auth/partner/me', data),
  resetPassword: (data: any) => ApiClient.post('/auth/partner/reset_password', data),
  changePassword: (data: any, token: string) =>
    ApiClient.post(`/auth/partner/change_password/${token}`, data),
  changePasswordSettings: (data: any) => ApiClient.post(`/auth/partner/change_password`, data),
  updateProfile: (data: any) => ApiClient.patch('/partners', data),
  googleAuth: () => ApiClient.get('/auth/google/partner/login'),
  googleAuthRegister: (data: any, token: string) =>
    ApiClient.post(`/auth/google/partner/registration?token=${token}`, data),
  updateProfileAvatar: (data: FormData) =>
    ApiClient.post('/partners/avatar', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }),
  moderationAccount: (data: any) => ApiClient.post('/auth/partner/additional_data', data),
  getBalance: () => ApiClient.get('/partners/balance'),
  getPendingAmount: () => ApiClient.get('/partners/orders/pending_amount'),
  getBalanceHistory: (params: any) => ApiClient.get('/partners/balance_history', { params }),
  getDashboardData: () => ApiClient.get('/partners/dashboard'),
  getDashboardDataIncome: (params?: any) => ApiClient.get('/partners/dashboard/income', { params }),
  getDashboardDataSubscribers: (params?: any) =>
    ApiClient.get('/partners/dashboard/subscribers', { params }),
  getDashboardDataConversions: (params?: any) =>
    ApiClient.get('/partners/dashboard/conversions', { params }),
  getWithdrawalOrders: (params?: any) => ApiClient.get('/partners/orders', { params }),
  createWithdrawalOrder: (data: any) => ApiClient.post('/partners/orders', data),
  getCplCampaignsStats: (params?: Record<string, any>) => {
    const defaults = {
      sort_by: 'created_at',
      id: true,
      model: true,
      clicks: true,
      click_percent: true,
      fans: true,
      revenue: true,
      three_messages: true,
      three_messages_percent: true,
      one_buy: true,
      one_buy_percent: true,
      apru: true,
      active_period: true,
    };

    return ApiClient.get('/partners/stats/campaigns/cpl', {
      params: {
        ...defaults,
        ...params,
      },
    });
  },
  getRefShareCampaignsStats: (params?: Record<string, any>) => {
    const defaults = {
      sort_by: 'created_at',
      id: true,
      model: true,
      clicks: true,
      click_percent: true,
      fans: true,
      revenue: true,
      three_messages: true,
      three_messages_percent: true,
      one_buy: true,
      one_buy_percent: true,
      apru: true,
      active_period: true,
    };

    return ApiClient.get('/partners/stats/campaigns/ref_share', {
      params: {
        ...defaults,
        ...params,
      },
    });
  },
  getLevelRequirements: () => ApiClient.get('/partners/lvl'),
  getLevelStats: () => ApiClient.get('/partners/lvl/stats'),
};

export default partnerAuthService;
